import { createContext } from "react";

type MeetingPageContextValueType = {
  sidebarMeetingView?: "overview" | "load-previous-meeting" | number;
  setSidebarMeetingView?: (
    view: "overview" | "load-previous-meeting" | number,
  ) => void;
  onChangeMeetingView?: (
    meetingView: string,
    isReviewMeeting?: boolean | null,
  ) => void;
  isInSidebar: boolean;
  isInExtension: boolean;
};

export const MeetingPageContext = createContext<MeetingPageContextValueType>({
  sidebarMeetingView: undefined,
  setSidebarMeetingView: undefined,
  onChangeMeetingView: undefined,
  isInSidebar: false,
  isInExtension: false,
});
